import { Box, Typography } from '@mui/material'
import { useContext } from 'react'

import { EthersContext } from '../Contexts'
import WorldBasePage from './WorldBasePage'

const EthersDebugPage: React.FC = () => {
  const { error, signer, provider, localAddress, chainId, currentNetwork, isConnected, walletProvider } = useContext(EthersContext)
  return (
    <WorldBasePage>
      <Box alignItems="center" display="flex" flexDirection="column" flexGrow={1} justifyContent="center" width="100vw">
        <Typography align="center" variant="h2">
          Ethers Required Tester
        </Typography>
        <Typography align="center" variant="body1">{`Error: ${error ?? 'None'}`}</Typography>
        <Typography align="center" variant="body1">{`signer: ${signer ?? 'None'}`}</Typography>
        <Typography align="center" variant="body1">{`provider: ${provider ?? 'None'}`}</Typography>
        <Typography align="center" variant="body1">{`localAddress: ${localAddress ?? 'None'}`}</Typography>
        <Typography align="center" variant="body1">{`chainId: ${chainId ?? 'None'}`}</Typography>
        <Typography align="center" variant="body1">{`currentNetwork: ${currentNetwork ?? 'None'}`}</Typography>
        <Typography align="center" variant="body1">{`WalletProvider: ${walletProvider ?? 'None'}`}</Typography>
        <Typography align="center" variant="body1">{`isConnected: ${isConnected ?? 'None'}`}</Typography>
      </Box>
    </WorldBasePage>
  )
}

export default EthersDebugPage
